import { AxiosPromise } from 'axios';
import api from './api';

interface AutenticateCredentials {
  username: string;
  password: string;
}

class AuthService {
  autenticate = (data: AutenticateCredentials): AxiosPromise => {
    return api.post('api/pjtacom/token/', data);
  };

  getTitular = (): AxiosPromise => {
    return api.get('api/pjtacom/titular/');
  };

  getCity = (code: string): AxiosPromise => {
    return api.get(`api/pjtacom/city/${code}/`);
  };

  changePassword = (
    oldPassword: string,
    newPassword: string,
    confirmNewPassword: string,
  ): AxiosPromise => {
    return api.post('api/pjtacom/change-password/', {
      old_password: oldPassword,
      new_password: newPassword,
      confirm_password: confirmNewPassword,
    });
  };

  resetPassword = (username: string): AxiosPromise => {
    return api.post('api/pjtacom/reset-password/', {
      username,
    });
  };

  acceptedLGPD = (user_id: number): AxiosPromise => {
    return api.get(`api/pjtacom/accepted-lgpd/${user_id}/`);
  };

  acceptLGPD = (user_id: number): AxiosPromise => {
    return api.post('api/pjtacom/accepted-lgpd/', {
      user_id,
    });
  };
}

export type { AutenticateCredentials };

export default AuthService;
